import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/home/Index.vue'
import NavContent from '@/views/home/NavContent.vue'
import Error from '@/views/error/Error.vue'
import { initStore } from '@/store'
import { isMobile } from '@/utils'
import Index from '@/views/init/main.vue'
import { initSingleGroupMemento, routerHandler } from './routerGuard'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Index,
    name: 'Index'
  },
  {
    path: '/:groupId(\\d+)',
    name: 'Home',
    components: {
      default: Home,
      notFound: Error // 空间异常态
    },
    props: {
      default: route => ({
        groupId: Number(route.params.groupId),
        navId: Number(route.query.nid)
      })
    },
    children: [
      {
        path: '',
        name: 'Nav',
        component: NavContent,
        props: route => ({
          groupId: Number(route.params.groupId),
          navId: Number(route.query.nid)
        })
      }
    ]
  },
  {
    path: '/:groupId(\\d+)/invite/:key',
    name: 'Join',
    component: Error
  },
  {
    path: '/group/:groupId(\\d+)/:pathMatch(.*)*',
    redirect: to => {
      const { params } = to
      return { name: 'Home', params: { groupId: params.groupId } }
    }
  },
  {
    path: '/:pathMatch(.*)',
    name: 'NotFound',
    component: Error
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

let fetched = false

router.beforeEach(async (to, from, next) => {
  if (isMobile()) {
    const url = `${location.origin}/m${to.fullPath}`
    location.href = url
    return
  }
  if (!fetched) {
    if (routerHandler[to.name as string]) {
      return routerHandler[to.name as string]([to, from, next]).finally(() => {
        fetched = true
      })
    } else {
      // 避免异常情况下不做任何初始化操作
      // 初始化store
      await initStore(to.params.groupId as string)
      await initSingleGroupMemento(to.params.groupId as string)
      fetched = true
    }
  }
  next()
})
export default router
